// frontend/modules/ess-monitoring/index.ts
import { ModuleConfig } from '@/core/module';
import { essMonitoringRoutes } from './routes';

// Export views
export { default as ESSMonitoringDashboardView } from './views/ESSMonitoringDashboardView';

export const ESSMonitoringModule: ModuleConfig = {
    name: 'ess-monitoring',
    routes: essMonitoringRoutes,
    initialize: () => {
        console.log('ESS Monitoring module initialized');
    }
};
